export const MAIN_ROUTE_NAME = {
  DASHBOARD: 'dashboard',
};

export const AUTH_ROUTE_NAME = {
  AUTH: 'auth',
  SIGNUP: 'signup',
  SIGNIN: 'signin',
  FORGOT_PASSWORD: 'forgot-password',
  RESET_PASSWORD: 'reset-password',
};

export const MANAGE_ROUTE_NAME = {
  MANAGE: 'manage',
  PRODUCT: 'product',
  CATEGORY: 'category',
  CUSTOMER: 'customer',
};

export const SETTING_ROUTE_NAME = {
  SETTING: 'setting',
};

export const ORDER_ROUTE_NAME = {
  ORDERS: 'orders',
  CUSTOMER_ORDERS: 'customer-orders',
  ORDER_DETAIL: 'order-detail',
  ORDER_PACKING: 'order-packing',
};

export const CUSTOMER_ROUTE_NAME = {
  CUSTOMER: 'customer',
  CUSTOMER_DETAIL: 'customer-detail',
  CUSTOMER_ADDRESS: 'customer-address',
};

export const ACCOUNT_ROUTE_NAME = {
  ACCOUNT: 'account',
  ACCOUNT_INFORMATION: 'account-information',
  CHANGE_PASSWORD: 'change-password',
};

export const PRODUCT_ROUTE_NAME = {
  PRODUCT: 'product',
  CATEGORY: 'category',
  ADD_CATEGORY: 'add-category',
  EDIT_CATEGORY: 'edit-category',
  PRODUCT_CATEGORY: 'product-category',
  ADD_PRODUCT: 'add-product',
  EDIT_PRODUCT: 'edit-product',
};

export const KOL_ROUTE_NAME = {
  KOL: 'kol',
  ADD_KOL: 'add-kol',
  KOL_REQUEST: 'kol-request',
  KOL_DETAIL: 'kol-detail',
}

export const PROMOTION_ROUTE_NAME = {
  PROMOTION: 'promotion',
  ADD_PROMOTION: 'add-promotion',
  EDIT_PROMOTION: 'edit-promotion',
  PROMOTION_DETAIL: 'promotion-detail',
}

export const COUPON_ROUTE_NAME = {
  COUPON_LIST: 'coupon-list',
  ADD_COUPON: 'add-coupon',
  EDIT_COUPON: 'edit-coupon',
  COUPON_DETAIL: 'coupon-detail',
}

export const SHIPMENT_ROUTE_NAME = {
  SHIPMENT_MANAGE: 'shipment-manage',
  SHIPMENT_DETAIL: 'shipment-detail',
  SHIPMENT_LIST: 'shipment-list',
}

export const WHOLESALE_ROUTE_NAME = {
  WHOLESALE_LIST: 'wholesale-list',
  ADD_WHOLESALE: 'add-wholesale',
  EDIT_WHOLESALE: 'edit-wholesale',
  WHOLESALE_DETAIL: 'wholesale-detail',
}

export const COMMISSION_ROUTE_NAME = {
  COMMISSION_CATEGORY_LIST: 'commission-category-list',
  ADD_COMMISSION_CATEGORY: 'add-commission-category',
  EDIT_COMMISSION_CATEGORY: 'edit-commission-category',
}
